const routes = {
  login: 'auth/login',
  logout: 'auth/logout',
  changePassword: 'auth/change-password',
  forgotPassword: 'auth/forgot-password',
  resetPassword: 'auth/reset-password/',
};

export default routes